import { GENRE_SOURCE_MAP } from '@intelligence/components/GenreSelect/constants';
import { getRobloxDefaultDeviceValue } from './config/robloxDeviceFilter';

import type { IGenreSelectValue } from '@intelligence/components/GenreSelect/types';
import type { IRobloxGameRankFilterValues } from './types';

export const PAGE_ID = 'robloxGameRank';
export const FILTER_SAVE_TYPE = 'roblox-game-rank';
export const ROBLOX_RANK_DEFAULT_PAGE_SIZE = 50;
export const ROBLOX_SEARCH_DROPDOWN_PAGE_SIZE = 20;
export const ROBLOX_DEFAULT_SELECT_GAME_NUM = 6;
export const ROBLOX_GAME_RANK_CHART_DAYS = 30;
export const ROBLOX_GAME_RANK_CHART_PAGE_SIZE = 100000;

/** 折线图 group_by（含 date） */
export const ROBLOX_GAME_RANK_CHART_GROUP_BY = ['game_id', 'date', 'source', 'device'];

/** 下载 group_by（与接口一致，含 market） */
export const ROBLOX_GAME_RANK_DOWNLOAD_GROUP_BY = [
  'date',
  'game_id',
  'source',
  'device',
  'market',
];

/** 表格/下载共用的 use_custom_fields */
export const ROBLOX_GAME_RANK_CUSTOM_FIELDS = [
  'entity_name',
  'cover',
  'roblox_genre',
  'roblox_sub_genre',
  'roblox_level_3_genre',
  'publisher',
  'release_time',
  'update_time',
];

/** 下载 use_custom_fields（与表格一致） */
export const ROBLOX_GAME_RANK_DOWNLOAD_CUSTOM_FIELDS = [
  ...ROBLOX_GAME_RANK_CUSTOM_FIELDS,
];

export const ROBLOX_GAME_RANK_DOWNLOAD_PAGE_SIZE = 5000;

export const ROBLOX_GAME_RANK_DOWNLOAD_USE_SSE_PAGE = {
  max_size: 10000,
};

/** 无对应筛选器的固定请求字段 */
export const ROBLOX_GAME_RANK_FIXED_FETCH_PARAMS = {
  group_by: ['game_id', 'source', 'device', 'market'],
  use_entity_type: 'roblox',
  use_custom_fields: [...ROBLOX_GAME_RANK_CUSTOM_FIELDS],
  order_by: ['date asc', 'rank asc'],
};

export const ROBLOX_GAME_RANK_SORT_KEY = 'rank_0';
export const ROBLOX_GAME_RANK_SORT_KEY_DOD = 'rank_1';

/** 榜单 UI 排序与接口 rank 字段方向相反：箭头向下(desc)时接口用 asc，保证 1、2、3 在前 */
export const mapRankSortUiOrderToApiOrder = (
  uiOrder: 'asc' | 'desc',
): 'asc' | 'desc' => (uiOrder === 'desc' ? 'asc' : 'desc');

export const getRobloxGameRankSortMetricByKey = (
  sortKey?: string,
): 'rank' | 'rank_dod' =>
  sortKey === ROBLOX_GAME_RANK_SORT_KEY_DOD ? 'rank_dod' : 'rank';

/** 表格默认排序展示配置（与 order_by 保持一致） */
export const ROBLOX_GAME_RANK_TABLE_SORT = {
  field: 'rank',
  fieldLabelKey: 'dbi_roblox_game_rank_sort_field',
  order: 'desc',
  sortKey: ROBLOX_GAME_RANK_SORT_KEY,
} as const;

const getDefaultGenreValue = (): IGenreSelectValue => ({
  source: GENRE_SOURCE_MAP.ROBLOX,
  genres: [],
});

export const getDefaultFilterValues = (): IRobloxGameRankFilterValues => {
  return {
    date: {
      granularity: 'daily',
      startDate: '',
      endDate: '',
    },
    region: ['us'],
    device: getRobloxDefaultDeviceValue(),
    genre: getDefaultGenreValue(),
  };
};
